export const SUPPLIER_API_URL = 'https://api-v3.printoclock.com';
export const SUPPLIER_API_VERSION = '/v1';
export const SUPPLIER_API_FULL_URL = SUPPLIER_API_URL+SUPPLIER_API_VERSION;
export const SENTRY_DSN = 'https://a4c4cf4577d842e28972e11e75026dd1@o4504563985743872.ingest.sentry.io/4504564006846464';
